import { render, staticRenderFns } from "./BaseFormAnnotation.vue?vue&type=template&id=862fe49c"
import script from "./BaseFormAnnotation.vue?vue&type=script&lang=js"
export * from "./BaseFormAnnotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports